var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a',_vm._g({staticClass:"dropdown-item",attrs:{"href":"#"},on:{"mousedown":function($event){$event.preventDefault();return _vm.chooseAddress.apply(null, arguments)},"click":function($event){$event.preventDefault();}}},_vm.$listeners),[_vm._v(" "+_vm._s(_vm.address.label)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }